import { Box, FormControl, FormControlLabel, Radio, RadioGroup } from '@mui/material'
import { useState } from 'react'
import { avaterUrl } from '../util/lib'

const typeAvaters = [
  {
    id: 'm20r',
    type: 'man',
  },
  {
    id: 'm40r',
    type: 'man',
  },
  {
    id: 'm70r',
    type: 'man',
  },
  {
    id: 'w20r',
    type: 'woman',
  },
  {
    id: 'w40r',
    type: 'woman',
  },
  {
    id: 'w70r',
    type: 'woman',
  },
] as const

type Props = {
  avater_id: string
  setAvater: (avater: string) => void
}
const AvaterSelecter: React.FC<Props> = ({avater_id, setAvater}) => {
  const [avaterType, setAvaterType] = useState<'man' | 'woman'>('man')
  const avaters = typeAvaters.filter(({type})=> type === avaterType)

  return <Box>
    <FormControl>
      <RadioGroup
        row
        value={avaterType}
        onChange={e=> setAvaterType(e.target.value as 'man' | 'woman')}
      >
        <FormControlLabel value="man" control={<Radio/>} label="Man"/>
        <FormControlLabel value="woman" control={<Radio/>} label="Woman"/>
      </RadioGroup>
    </FormControl>

    <div style={{textAlign: 'center'}}>
      {avaters.map(({id})=> (
        <img
          key={id}
          src={avaterUrl(id)}
          alt={id}
          style={{
            cursor: 'pointer', margin: '4px',
            border: avater_id === id ? 'dashed 3px #aaa' : 'none',
            backgroundColor: avater_id === id ? '#eef' : 'white',
            maxHeight: '250px', borderRadius: '6px',
            boxSizing: 'border-box',
          }}
          onClick={()=> { setAvater(id) }}
        />
      ))}
    </div>
  </Box>
}
export default AvaterSelecter
